/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Dimensions, Platform, Text, View} from 'react-native';
import {connect} from 'react-redux';
import {ConnexionTitle} from '../../../../../data/constants/titles';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {BoxShadowed} from '../../../../components/Assurance/Voyage/Container';
import PrimaryButton from '../../../../components/Button/PrimaryButton';
import Label from '../../../../components/Label';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../../components/PageContainer';

import {
  countPersonsInAgeRanges,
  findOldestDate,
  getOldestDate,
} from '../../../../../common/utils/functions';
import {dataConfig} from '../../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {BREAKPOINT} from '../../../../../data/constants/screen';
import {mapAgence} from '../../../../../data/factory/agence';
import {ApiResponse} from '../../../../../data/types/interface/api';
import {SubmitDevisVoyage} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {VoyageServices} from '../../../../../services/applicatif/voyages';
import {SelectType} from '../../../../components/AssuranceVoyage/SelectType';
import {buttonsStyles} from '../../../../components/Button/boutonStyle';
import {itemI} from '../../../../components/Inputs/DatePickerModal/MultiDatePicker';
import {Loader} from '../../../../components/Loader';
import {styles} from './styles';

interface ResultProps {
  datas: SubmitDevisVoyage;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  navigate: Function;
  onCancel: () => void;
  user: Record<string, any>;
  listCategory: Array<any>;
  getAgence: any;
}
const ResultFC = ({
  datas,
  listCategory,
  navigate,
  onCancel,
  user,
  getAgence,
}: ResultProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [selectedType, setSelectedType] = useState<string>('');
  const [contratMessages, setContratMessages] = useState<string[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {saveDevis} = VoyageServices();
  interface ModalDataDTO {
    status: boolean;
    title: string;
    message: string;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    action: Function;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    cancel: Function | undefined;
    button1Label: string;
    button2Label: string | undefined;
  }
  const initModalDatas: ModalDataDTO = {
    status: false,
    title: '',
    message: '',
    action: () => {},
    cancel: () => {},
    button1Label: '',
    button2Label: '',
  };
  const [modalDatas, setModalDatas] = React.useState<ModalDataDTO>({
    ...initModalDatas,
  });

  const categorizedAges = datas.listNaissance.length
    ? countPersonsInAgeRanges(
        datas.listNaissance,
        {
          childrens: {
            min: dataConfig.ageGap.enfant.min,
            max: dataConfig.ageGap.enfant.max,
          },
          adults: {
            min: dataConfig.ageGap.adult.min,
            max: dataConfig.ageGap.adult.max,
          },
          seniors: {
            min: dataConfig.ageGap.senior.min,
            max: dataConfig.ageGap.senior.max,
          },
        },
        'value',
      )
    : {childrens: 0, adults: 0, seniors: 0};
  const getDataToSend = (datas: any) => {
    const montant =
      datas.type.length === 1
        ? datas.type[0].montant
        : datas.type.find(
            (element: any) => element.destination === selectedType,
          )?.montant;
    const quoteCode =
      datas.type.length === 1
        ? datas.type[0].quoteCode
        : datas.type.find(
            (element: any) => element.destination === selectedType,
          )?.quoteCode;

    return {
      ...datas,
      montant: montant,
      quoteCode: quoteCode,
    };
  };
  const handleConnection = () => {
    setModalDatas({
      status: true,
      title: ConnexionTitle,
      message: '',
      action: () => {
        setModalDatas({...initModalDatas});
        navigate('Login', {
          data: 'SouscriptionAssuranceVoyage',
          params: {
            ...getDataToSend(datas),
          },
        });
      },
      cancel: () => setModalDatas({...initModalDatas}),
      button1Label: 'Connexion',
      button2Label: 'Annuler',
    });
  };
  const coutDays = (): number => {
    const dateDebut: any = new Date(datas?.dateDebut);
    const dateFin: any = new Date(datas?.dateFin);
    const differenceEnMillisecondes = dateFin - dateDebut;
    const differenceEnJours = differenceEnMillisecondes / (1000 * 60 * 60 * 24);

    return Math.round(differenceEnJours);
  };
  const settingMessages = () => {
    const days = coutDays();

    if (days >= 90 && days < 180) {
      setContratMessages([
        'Votre contrat dure 180 jours sans dépasser 92 jours pour un seul voyage',
        'Votre contrat dure 180 jours sans dépasser 180 jours pour un seul voyage',
      ]);
    }
    if (days >= 180) {
      setContratMessages([
        'Votre contrat dure une (1) année sans dépasser 92 jours pour un seul voyage',
        'Votre contrat dure une (1) année sans dépasser 180 jours pour un seul voyage',
      ]);
    }
  };

  useEffect(() => {
    settingMessages();
  }, []);

  const handleSubmit = () => {
    const datasToSend = getDataToSend(datas);
    setIsLoading(() => true);
    getAgence({}, (res: any) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);

        user.data?.utilisateur && datasToSend
          ? navigate('SouscriptionAssuranceVoyage', {
              ...datasToSend,
              listAgence: [..._list],
              listCategory: listCategory,
            })
          : handleConnection();
      }
    });
  };

  const handleSaveDevis = (values: SubmitDevisVoyage) => {
    const oldest = dayjs(findOldestDate(values.listNaissance, 'value')).format(
      'YYYY-MM-DD',
    );

    const nbrAges = countPersonsInAgeRanges(
      values.listNaissance,
      {
        childrens: {
          min: dataConfig.ageGap.enfant.min,
          max: dataConfig.ageGap.enfant.max,
        },
        adults: {
          min: dataConfig.ageGap.adult.min,
          max: dataConfig.ageGap.adult.max,
        },
        seniors: {
          min: dataConfig.ageGap.senior.min,
          max: dataConfig.ageGap.senior.max,
        },
      },
      'value',
    );

    setIsLoading(true);
    saveDevis({
      idCategory: values.idCategory,
      idDestination: values.idDestination,
      dateDebut: values.dateDebut,
      dateFin: values.dateFin,
      listNaissance: values.listNaissance.map((elt: itemI) =>
        dayjs(elt.value).toDate().toDateString(),
      ),
      dateNaissance: oldest,
      enfant: String(nbrAges.childrens),
      adult: String(nbrAges.adults),
      senior: String(nbrAges.seniors),
      motif: values.motif,
    })
      .then((res: ApiResponse) => {
        setIsLoading(false);
        if (!res?.isError) {
          setModalDatas({
            status: true,
            title: 'Information',
            message:
              'Votre devis à bien été enregistré dans votre liste de devis.',
            action: () => {
              setModalDatas({...initModalDatas});
              navigate('ListDevisAssuranceVoyage');
            },
            cancel: undefined,
            button1Label: 'Ok',
            button2Label: undefined,
          });
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const ResultButtons = () =>
    Dimensions.get('window').width > BREAKPOINT.sm ? (
      <View style={[styles.buttonContainerWeb]}>
        <PrimaryButton
          onPress={() => onCancel()}
          styleBtnTxt={buttonsStyles.btnAnnuler}
          styleContainer={styles.noFlexGrow}
          styleBtnOuter={[buttonsStyles.btnAnnulerOuterSimu, {maxWidth: 200}]}
          title="Refaire un devis"
          type="annuler"
        />
        {user.data?.utilisateur ? (
          <PrimaryButton
            onPress={() => handleSaveDevis(datas)}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={[buttonsStyles.btnAnnulerOuterSimu, {maxWidth: 200}]}
            title="Sauvegarder ce devis"
            type="annuler"
          />
        ) : null}
        <PrimaryButton
          onPress={handleSubmit}
          styleBtnTxt={[styles.buttonText]}
          styleBtnOuter={[styles.buttonOuter, {maxWidth: 200}]}
          title={'Souscrire'}
          type="valider"
          isDisable={datas.type.length > 1 && !selectedType}
        />
      </View>
    ) : (
      <View style={[styles.buttonContainer]}>
        <View style={[styles.buttonContent]}>
          <PrimaryButton
            onPress={() => onCancel()}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={[buttonsStyles.btnAnnulerOuterSimu]}
            title="Refaire un devis"
            type="annuler"
          />
          {user.data?.utilisateur ? (
            <PrimaryButton
              onPress={() => handleSaveDevis(datas)}
              styleBtnTxt={buttonsStyles.btnAnnuler}
              styleBtnOuter={[buttonsStyles.btnAnnulerOuterSimu]}
              title="Sauvegarder ce devis"
              type="annuler"
            />
          ) : null}
        </View>
        <View style={[styles.buttonContent]}>
          <PrimaryButton
            onPress={handleSubmit}
            styleBtnTxt={[styles.buttonText]}
            styleBtnOuter={[styles.buttonOuter]}
            title={'Souscrire'}
            type="valider"
            isDisable={datas.type.length > 1 && !selectedType}
          />
        </View>
      </View>
    );

  const oldestDateNaissance = useMemo(() => {
    return (
      dayjs(
        datas.listNaissance.length &&
          getOldestDate(datas.listNaissance.map((elt: itemI) => elt.value)),
      ).format('DD/MM/YYYY') ?? 'Pas de date'
    );
  }, [datas]);

  const formatDateToString = useCallback(
    (date: Date) => dayjs(date).format('DD/MM/YYYY'),
    [],
  );

  return (
    <View style={styles.wholeContainer}>
      {isLoading ? (
        <Loader />
      ) : (
        <PageContainer style={[styles.container]}>
          <Label title="ASSURANCE VOYAGE" type="mainTitle" />
          <Label title="Veuillez-trouver ci-après votre devis" />

          <BoxShadowed>
            <View>
              <Label title={'Catégorie :'} type="titleGreen14" />
              <Label title={datas.categoryLabel} />
            </View>
            <View>
              <Label title={'Destination :'} type="titleGreen14" />
              <Label title={datas.destinationLabel} />
            </View>
            <View>
              <Label title={'Date de naissance :'} type="titleGreen14" />
              <Label title={oldestDateNaissance} />
            </View>

            <View>
              <Label title={'Vous voyagez du :'} type="titleGreen14" />
              <Label
                title={`${formatDateToString(
                  datas.dateDebut,
                )} au ${formatDateToString(datas.dateFin)}`}
              />
            </View>
            <Text>
              {categorizedAges.childrens ? (
                <>
                  <Label title={String(categorizedAges.childrens)} />
                  <Label
                    title={` enfant${
                      categorizedAges.childrens > 1 ? 's' : ''
                    } `}
                    type="titleGreen14"
                  />
                </>
              ) : null}
              {categorizedAges.adults ? (
                <>
                  <Label title={String(categorizedAges.adults)} />
                  <Label
                    title={` adulte${categorizedAges.adults > 1 ? 's' : ''} `}
                    type="titleGreen14"
                  />
                </>
              ) : null}
              {categorizedAges.seniors ? (
                <>
                  <Label title={String(categorizedAges.seniors)} />
                  <Label
                    title={` senior${categorizedAges.seniors > 1 ? 's' : ''} `}
                    type="titleGreen14"
                  />
                </>
              ) : null}
            </Text>
          </BoxShadowed>

          {datas.type.length > 1 ? (
            <Label
              style={{marginTop: 40}}
              textStyle={{textAlign: 'center'}}
              title="Veuillez choisir le type de Paiement"
              type="titleGreen14"
            />
          ) : null}

          <SelectType
            listTypes={datas.type}
            onSelect={(name: string, value: string) => setSelectedType(value)}
            selected={selectedType}
            messages={contratMessages}
            sejour={coutDays()}
          />
          {Platform.OS === 'web' ? (
            <View style={{alignItems: 'center', flexWrap: 'wrap'}}>
              <ResultButtons />
              <View style={{height: 120}} />
            </View>
          ) : null}
        </PageContainer>
      )}
      {Platform.OS !== 'web' ? <ResultButtons /> : null}

      {modalDatas.status && (
        <ConfirmationModal
          title={modalDatas.title}
          content={modalDatas.message}
          btn1={modalDatas.button1Label}
          btn2={modalDatas.button2Label}
          handleBtn1={modalDatas.action}
          handleBtn2={modalDatas.cancel}
        />
      )}
    </View>
  );
};
export const Result: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResultFC);
